import { ImportType } from 'library/ts/model/enums/config/ImportType';
import { LogService } from 'library/ts/utilities/logger/LogService';
export class Importer {
    #logger;
    constructor() {
        this.#logger = LogService.create({ prefixes: ['SmartTag:', this.name + ':'] });
    }
    get name() {
        return 'Importer';
    }
    import = (imports = [], sequence = false, stepDelay = undefined) => {
        const utils = window?.PARA?.PlayerServices?.Utilities;
        let numScripts = 0;
        let scriptsLoaded = 0;
        const isPresent = (importVO) => {
            return utils.Import.alreadyPresent(importVO.url, importVO.namespace);
        };
        return new Promise((resolve, reject) => {
            const loadSequential = (scriptsLoaded) => {
                const importVO = imports[scriptsLoaded];
                const isComplete = () => {
                    if (scriptsLoaded < numScripts) {
                        this.#logger.log(scriptsLoaded, numScripts, 'Not complete yet...');
                        setTimeout(() => {
                            importVO.exists = isPresent(importVO);
                            importVO.failed = !isPresent(importVO);
                            loadSequential(scriptsLoaded);
                        }, stepDelay);
                    }
                    else {
                        this.#logger.log(scriptsLoaded, numScripts, 'all done...');
                        const loaded = [];
                        const failed = [];
                        for (let i = 0; i < imports.length; i++) {
                            imports[i].failed = !imports[i].exists;
                            if (imports[i].exists === true)
                                loaded.push(imports[i]);
                            if (imports[i].failed === true || imports[i].exists === false)
                                failed.push(imports[i]);
                        }
                        switch (failed.length === 0) {
                            case true:
                                resolve({
                                    message: 'success',
                                    imports: loaded
                                });
                                break;
                            case false:
                                reject({
                                    message: 'failure',
                                    imports: failed
                                });
                                break;
                        }
                    }
                };
                switch (isPresent(importVO)) {
                    case true:
                        importVO.exists = true;
                        importVO.failed = false;
                        scriptsLoaded++;
                        isComplete();
                        break;
                    case false:
                        const method = (importVO.type === ImportType.SCRIPT ? utils.Import.loader.js : utils.Import.loader.css);
                        Promise.all([method(importVO, false, utils)]).then((data) => {
                            this.#logger.log('Resolved!', data[0]);
                            data[0].exists = isPresent(data[0]);
                            data[0].failed = false;
                            scriptsLoaded++;
                            isComplete();
                        }).catch((data) => {
                            this.#logger.warn('Rejected!', data[0]);
                            data[0].failed = true;
                            scriptsLoaded++;
                            isComplete();
                        });
                        break;
                }
            };
            const load = () => {
                const tasks = [];
                for (let i = 0; i < imports.length; i++) {
                    const method = (imports[i].type === ImportType.SCRIPT ? utils.Import.loader.js : utils.Import.loader.css);
                    tasks.push(method(imports[i], false, utils));
                }
                Promise.all(tasks).then((messages) => {
                    this.#logger.log('Resolved!', messages);
                }).catch((error) => {
                    this.#logger.warn('Rejected!', error);
                });
            };
            switch (imports.length > 0) {
                case true:
                    numScripts = imports.length;
                    scriptsLoaded = 0;
                    switch (sequence) {
                        case true:
                            loadSequential(scriptsLoaded);
                            break;
                        case false:
                            load();
                            break;
                    }
                    break;
                case false:
                    resolve({ message: 'Imports loaded', imports: imports });
                    break;
            }
        });
    };
}
